const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        label: '년도',
        value: 'year',
        query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['년도', '회의일', '참석인원']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "년도",
        "key": "header.year"
      },
      {
        "name": "회의구분",
        "key": "body.회의구분"
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "회의일",
        "key": "body.회의일"
      },
      {
        "name": "참석인원",
        "key": "body.참석인원"
      },
    ]
  },
  getCol: (index, value, func) => {
    const postContent = JSON.parse(value.post_content);
    try {
      switch (index) {
        case 0: return postContent.header.year // 년도
        case 1: return func.getContent(value).회의구분 // 회의구분
        case 2: return func.getContent(value).stdInfo.field_name // 사업장명
        case 3: return func.getContent(value).회의일 // 회의일
        case 4: return func.getContent(value).참석인원 // 참석인원
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
